import React from 'react'

import DemoForm from '@toasttab/main/src/components/DemoForm/DemoForm'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const DemoRequest = ({ body }: { body: any }) => {
  return (
    <section className='relative before:content-[""] before:w-full before:h-full before:absolute before:bg-top-brand-50-gradient lg:before:bg-left-brand-50-gradient before:rounded-[1.5rem] lg:before:rounded-[3rem] before:top-0 mb-10 lg:mb-16 bg-cover bg-no-repeat bg-center bg-brand-50 bg-hp-brand-line-Mobile lg:bg-hp-brand-line-Desktop rounded-[1.5rem] lg:rounded-[3rem] py-6 lg:py-[4.5rem]'>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid relative z-20'>
          <div className='col-span-4 lg:col-span-6 grid justify-center content-center px-6 lg:px-10 lg:max-w-[544px] z-20'>
            <Typography
              allowHtml={false}
              as='h2'
              classes='font-effra font-normal text-[3.313rem] leading-[4rem] mb-4 text-center text-primary text-white'
              variation='h2'
            >
              {body.columns.left.heading}
            </Typography>
            <Typography
              allowHtml={false}
              as='h4'
              classes='!font-effra !font-normal text-[1.375rem] mb-6 text-center text-secondary text-white'
              variation='h4'
            >
              {body.columns.left.description}
            </Typography>
            <img
              alt={body.columns.left.assets.image.title}
              className='mb-6 lg:mb-0 justify-self-center'
              src={body.columns.left.assets.image.src}
            />
          </div>
          <div className='col-span-4 lg:col-span-6 lg:max-w-[544px] z-20'>
            <div className='bg-white rounded-[0.625rem] p-6 lg:p-8'>
              <Typography
                allowHtml={false}
                as='h3'
                classes='font-effra font-normal text-[2.688rem] leading-[3rem] mb-6 text-primary'
                variation='h3'
              >
                {body.columns.right.form.heading}
              </Typography>
              <DemoForm
                fieldIdPrefix='ContentfulHomePageDemoRequest'
                formData={body.columns.right.form.data}
                heapInteractionSubmit='hprefine_bottomdemoMQL_submit'
                privacyStatementCenter={false}
                useRecaptcha={false}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DemoRequest
